import { PolygonColours, PolygonTypes } from "../../polygonTypes";

export function draw(
  visualisation,
  drawingLibrary,
  lastDraggedVertex,
  mPerPixel,
  plantList
) {
  drawingLibrary.clear();
  drawingLibrary.background("#ffffff");
  // draw a grid of 1m squares using vertical and horizontal line to match the canvas height and width
  drawingLibrary.stroke(150);
  drawingLibrary.strokeWeight(1);
  drawingLibrary.fill(0);

  // draw grid
  let gridSpacing = 20;
  let gridWidth = drawingLibrary.width / gridSpacing;
  let gridHeight = drawingLibrary.height / gridSpacing;
  for (let i = 0; i < gridWidth; i++) {
    drawingLibrary.line(
      i * gridSpacing,
      0,
      i * gridSpacing,
      drawingLibrary.height
    );
  }
  for (let i = 0; i < gridHeight; i++) {
    drawingLibrary.line(
      0,
      i * gridSpacing,
      drawingLibrary.width,
      i * gridSpacing
    );
  }

  // translate to offset X and Y
  drawingLibrary.translate(visualisation.xOffset(), visualisation.yOffset());
  // scale to zoom
  drawingLibrary.scale(visualisation.zoom());

  // draw polygons
  for (let i = 0; i < visualisation.polygons().length; i++) {
    let polygon = visualisation.polygons()[i].verticies();
    let fillColour = PolygonColours[visualisation.polygons()[i].type()];
    if (fillColour) {
      drawingLibrary.fill(fillColour);
    } else {
      drawingLibrary.noFill();
    }

    drawingLibrary.stroke(0);

    // if type is polygonType.BORDER then dotted line
    if (visualisation.polygons()[i].type() === PolygonTypes.BORDER) {
      drawingLibrary.strokeWeight(2);
      drawingLibrary.stroke(0);
      drawingLibrary.drawingContext.setLineDash([5, 15]);
    } else {
      drawingLibrary.strokeWeight(1);
      drawingLibrary.drawingContext.setLineDash([]);
    }

    drawingLibrary.beginShape();
    for (let j = 0; j < polygon.length; j++) {
      drawingLibrary.vertex(polygon[j].x, polygon[j].y);
    }
    drawingLibrary.endShape(drawingLibrary.CLOSE);

    // end line dash
    drawingLibrary.drawingContext.setLineDash([]);

    // label polygon
    drawingLibrary.strokeWeight(1);
    drawingLibrary.stroke(0);
    drawingLibrary.fill(0);
    drawingLibrary.textSize(14);
    drawingLibrary.textAlign(drawingLibrary.CENTER, drawingLibrary.CENTER);
    // finnd the center of the polygon
    let polygonCenter = { x: 0, y: 0 };
    for (let j = 0; j < polygon.length; j++) {
      polygonCenter.x += polygon[j].x;
      polygonCenter.y += polygon[j].y;
    }
    polygonCenter.x /= polygon.length;
    polygonCenter.y /= polygon.length;

    drawingLibrary.text(
      visualisation.polygons()[i].name(),
      polygonCenter.x,
      polygonCenter.y
    );
  }

  // draw current polygon
  if (visualisation.currentPolygon().length > 0) {
    drawingLibrary.noFill();
    drawingLibrary.stroke(0);
    drawingLibrary.beginShape();
    for (let i = 0; i < visualisation.currentPolygon().length; i++) {
      drawingLibrary.vertex(
        visualisation.currentPolygon()[i].x,
        visualisation.currentPolygon()[i].y
      );
    }
    drawingLibrary.endShape(drawingLibrary.CLOSE);

    // draw vertices of current polygon
    for (let i = 0; i < visualisation.currentPolygon().length; i++) {
      drawingLibrary.stroke(0);
      drawingLibrary.fill(255);
      drawingLibrary.ellipse(
        visualisation.currentPolygon()[i].x,
        visualisation.currentPolygon()[i].y,
        10,
        10
      );
    }
  }
  // draw verticies for selected polygon
  if (
    visualisation.selectedPolygon() &&
    !visualisation.selectedPolygon().locked()
  ) {
    let polygon = visualisation.selectedPolygon().verticies();
    for (let i = 0; i < polygon.length; i++) {
      //black stroke
      drawingLibrary.stroke(0);
      // if its lastDraggedVertex then yellow fill
      if (
        lastDraggedVertex !== null &&
        lastDraggedVertex.polygonIndex ===
          visualisation
            .polygons()
            .findIndex(
              (polygon) => polygon === visualisation.selectedPolygon()
            ) &&
        lastDraggedVertex.vertexIndex === i
      ) {
        drawingLibrary.fill(255, 255, 0);
      } else {
        drawingLibrary.fill(255, 0, 0);
      }
      drawingLibrary.ellipse(polygon[i].x, polygon[i].y, 10, 10);
    }
  }

  // Label each line with its length using mPerPixel
  drawingLibrary.stroke(0);
  drawingLibrary.fill(0);
  drawingLibrary.textSize(20);
  drawingLibrary.textAlign(drawingLibrary.CENTER, drawingLibrary.CENTER);
  for (let i = 0; i < visualisation.polygons().length; i++) {
    let poly = visualisation.polygons()[i];
    // if not selected then dont label
    if (!poly.selected()) {
      continue;
    }
    let polygon = poly.verticies();
    for (let j = 0; j < polygon.length - 1; j++) {
      let vertex1 = polygon[j];
      let vertex2 = polygon[j + 1];
      let midPoint = {
        x: (vertex1.x + vertex2.x) / 2,
        y: (vertex1.y + vertex2.y) / 2,
      };
      let distance = drawingLibrary.dist(
        vertex1.x,
        vertex1.y,
        vertex2.x,
        vertex2.y
      );
      // write distance in meters and feet
      drawingLibrary.text(
        `${(distance * mPerPixel).toFixed(1)}m`,
        midPoint.x,
        midPoint.y
      );
      // // write distance in feet
      // drawingLibrary.text(
      //   `${(distance * mPerPixel * 3.28084).toFixed(1)}ft`,
      //   midPoint.x,
      //   midPoint.y + 20
      // );
    }
    //draw the last line
    let vertex1 = polygon[polygon.length - 1];
    let vertex2 = polygon[0];
    let midPoint = {
      x: (vertex1.x + vertex2.x) / 2,
      y: (vertex1.y + vertex2.y) / 2,
    };
    let distance = drawingLibrary.dist(
      vertex1.x,
      vertex1.y,
      vertex2.x,
      vertex2.y
    );
    drawingLibrary.text(
      `${(distance * mPerPixel).toFixed(1)}m`,
      midPoint.x,
      midPoint.y
    );
  }
  // draw distance for current polygon
  if (visualisation.currentPolygon().length > 1) {
    for (let i = 0; i < visualisation.currentPolygon().length; i++) {
      // if last vertex then draw distance between last and first vertex
      let vertex1, vertex2;
      if (i === visualisation.currentPolygon().length - 1) {
        vertex1 = visualisation.currentPolygon()[i];
        vertex2 = visualisation.currentPolygon()[0];
      } else {
        vertex1 = visualisation.currentPolygon()[i];
        vertex2 = visualisation.currentPolygon()[i + 1];
      }
      let midPoint = {
        x: (vertex1.x + vertex2.x) / 2,
        y: (vertex1.y + vertex2.y) / 2,
      };
      let distance = drawingLibrary.dist(
        vertex1.x,
        vertex1.y,
        vertex2.x,
        vertex2.y
      );
      drawingLibrary.text(
        `${(distance * mPerPixel).toFixed(1)}m`,
        midPoint.x,
        midPoint.y
      );
      // in feet
      drawingLibrary.text(
        `${(distance * mPerPixel * 3.28084).toFixed(1)}ft`,
        midPoint.x,
        midPoint.y + 20
      );
    }
  }

  // draw plants of selected polygon
  if (visualisation.selectedPolygon()) {
    let polygon = visualisation.selectedPolygon().plants();
    for (let i = 0; i < polygon.length; i++) {
      let plant = polygon[i];
      let x = plant.x;
      let y = plant.y;
      if (x == null && y == null) {
        continue;
      }
      // if undefined
      if (x === undefined || y === undefined) {
        continue;
      }
      let plantInfo = plantList.find((p) => p.name === plant.name);
      let width = 20;
      let height = 20;
      if (plantInfo) {
        width = plantInfo.width / mPerPixel;
        height = plantInfo.height / mPerPixel;
      }
      // draw a cricle at x and y then label with plant name
      // if plant is selected then draw a red outline
      let isSelected = visualisation.selectedPlant() === plant;
      let isSamePlant =
        visualisation.selectedPlant() &&
        visualisation.selectedPlant().name === plant.name;
      if (isSelected) {
        drawingLibrary.stroke(255, 0, 0);
        drawingLibrary.strokeWeight(2);
      } else {
        if (isSamePlant) {
          drawingLibrary.stroke(0, 255, 0);
          drawingLibrary.strokeWeight(2);
        } else {
          drawingLibrary.stroke(0, 0, 255, 0);
          drawingLibrary.strokeWeight(1);
        }
      }
      // drawingLibrary.stroke(0, 0, 255, 0);
      // fill white with opactiy
      drawingLibrary.fill(0, 128, 85, 100);
      drawingLibrary.ellipse(x, y, width, width);
      drawingLibrary.textSize(14);

      // draw small slightly darker dot at center
      drawingLibrary.stroke(0, 0, 255, 0);
      // fill white with opactiy
      drawingLibrary.fill(0, 128, 85, 200);
      drawingLibrary.ellipse(x, y, 3, 3);

      // if selected draw plant name
      if (isSelected) {
        //black
        drawingLibrary.stroke(0);
        drawingLibrary.strokeWeight(0);
        drawingLibrary.fill(0);

        drawingLibrary.textAlign(drawingLibrary.CENTER, drawingLibrary.CENTER);
        drawingLibrary.text(plant.name, x, y - 10);
      }

      // drawingLibrary.textAlign(drawingLibrary.CENTER, drawingLibrary.CENTER);

      // drawingLibrary.text(plant.name, x, y);
    }
  }
}
